module.exports = __webpack_public_path__ + "img/ic_burger_story-active.3f6744ad.svg";